import Vue from 'vue'
import { checkCode } from '@/assets/js/utils'
const Directives = {
  install(Vue) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    const compositionstart = (e) => {
      e.target.composing = true
    }
    const compositionend = (e) => {
      e.target.composing = false
      trigger(e.target, 'input')
    }
    let initId = 0
    const DInitFun = function(handler) {
      const id = initId++
      const bindFun = (el, binding) => {
        const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
        if (!ele[id]) {
          ele[id] = {
            oldCallback: null,
            oldValue: null
          }
        }
        const oldData = ele[id]
        const value = (binding.value && binding.value.toString()) || undefined
        if (oldData.oldValue !== value) {
          oldData.oldValue = value
          if (oldData.oldCallback) {
            ele.removeEventListener('keyup', oldData.oldCallback)
            ele.removeEventListener('blur', oldData.oldCallback)
            ele.removeEventListener('compositionstart', compositionstart)
            ele.removeEventListener('compositionend', compositionend)
          }
          const callback = (e) => {
            if (!e.target.composing) {
              handler(ele, binding)
              trigger(ele, 'input')
            }
          }
          ele.addEventListener('keyup', callback)
          ele.addEventListener('blur', callback)
          ele.addEventListener('compositionstart', compositionstart)
          ele.addEventListener('compositionend', compositionend)
          oldData.oldCallback = callback
        }
      }
      return {
        mounted: bindFun,
        updated: bindFun,
        inserted: bindFun,
        update: bindFun
      }
    }
    const DInputPoint2 = (ele, binding) => {
      let value = ele.value + ''
      const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
      const regSome = /[0-9]+\.?[0-9]{0,3}/ // 两位小数输入部分时的限制规则
      const matchRes = value.match(reg)
      if (matchRes) {
        // 符合 不需要做删减操作
      } else {
        // 若不符合 看是否符合部分
        const matchResSome = value.match(regSome)
        if (matchResSome) {
          const reg1 = /0*([1-9]\d*|0\.\d+)/
          const reg2 = /(?:\.0*|(\.\d+?)0+)$/
          value = matchResSome[0].replace(reg1, '$1').replace(reg2, '$1')
        } else {
          value = ''
        }
      }
      ele.value = value
    }
    Vue.directive('direForm', DInitFun(DInputPoint2))
    Vue.directive('auth', {
      // v-auth="'B_ALARMRULEMANAGEMENT_QUERY'"
      inserted(el, binding) {
        if (!checkCode(binding.value)) {
          el.style.display = 'none'
        }
      }
    })
    //自定义指令-正数
    Vue.directive('format', {
      inserted: function(el, binding) {
        el.addEventListener('keypress', function(e) {
          e = e || window.event
          let key = e.key
          let val = e.target.value
          let reg = /^[0-9]d*$/ //正数
          if (!reg.test(key)) {
            e.preventDefault()
          }
        })
      }
    })
    //自定义指令-两位小数
    Vue.directive('format1', {
      inserted: function(el, binding) {
        el.addEventListener('keypress', function(e) {
          e = e || window.event
          let val = e.target.value
          let patter = /^\d+(\.\d{0,0})?$/ //两位小数正则
          if (e.key == '-') {
            e.preventDefault()
          } else {
            if (val) {
              if (!patter.test(val)) {
                e.preventDefault()
              }
            }
          }
        })
      }
    })
    //自定义指令-两位小数
    Vue.directive('format2', {
      inserted: function(el, binding) {
        el.addEventListener('keypress', function(e) {
          e = e || window.event
          let val = e.target.value
          let patter = /^\d+(\.\d{0,1})?$/ //两位小数正则
          if (e.key == '-') {
            e.preventDefault()
          } else {
            if (val) {
              if (!patter.test(val)) {
                e.preventDefault()
              }
            }
          }
        })
      }
    })
    //自定义指令-三位小数
    Vue.directive('format3', {
      inserted: function(el, binding) {
        el.addEventListener('keypress', function(e) {
          e = e || window.event
          let val = e.target.value
          let patter = /^\d+(\.\d{0,2})?$/ //三位小数正则
          if (e.key == '-') {
            e.preventDefault()
          } else {
            if (val) {
              if (!patter.test(val)) {
                e.preventDefault()
              }
            }
          }
        })
      }
    })
    Vue.directive('formatn', {
      // 当被绑定的元素插入到 DOM 中时……
      componentUpdated: function(el, binding, vnode) {
        console.log(vnode.data)
        const reg = Number(binding.value)
        let tmp = vnode.data.domProps.value //获取输入数据
        //记录小数点后几位存\d字符串
        let tmpstr = ''
        for (let i = 0; i < reg; i++) {
          tmpstr += '\\d' //拼接'\d'
        }
        let tmp2 = '^(\\d+)\\.(' + tmpstr + ').*$' // 把\d写成\\d才会被识别为\d字符串
        let re = new RegExp(tmp2, '') //字符串转正则

        if (tmp != '') {
          tmp = tmp.replace(/[^\d.]/g, '') //全局查找非数字 替换成空
          tmp = tmp.replace(/\.{2,}/g, '.')
          tmp = tmp.replace(/^\./g, '0.')
          tmp = tmp.replace(/^\d*\.\d*\./g, tmp.substring(0, tmp.length - 1))
          tmp = tmp.replace(/^0[^\.]+/g, '0')
          tmp = tmp.replace(re, '$1.$2')
          el.value = tmp
          el.dispatchEvent(new Event('input'))
        }
      }
    })
    Vue.directive('dialogDrag', {
      bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header')
        const dragDom = el.querySelector('.el-dialog')
        //dialogHeaderEl.style.cursor = 'move';
        dialogHeaderEl.style.cssText += ';cursor:move;'
        dragDom.style.cssText += ';top:0px;'

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = (function() {
          if (window.document.currentStyle) {
            return (dom, attr) => dom.currentStyle[attr]
          } else {
            return (dom, attr) => getComputedStyle(dom, false)[attr]
          }
        })()

        dialogHeaderEl.onmousedown = (e) => {
          // 鼠标按下，计算当前元素距离可视区的距离
          const disX = e.clientX - dialogHeaderEl.offsetLeft
          const disY = e.clientY - dialogHeaderEl.offsetTop

          const screenWidth = document.body.clientWidth // body当前宽度
          const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)

          const dragDomWidth = dragDom.offsetWidth // 对话框宽度
          const dragDomheight = dragDom.offsetHeight // 对话框高度

          const minDragDomLeft = dragDom.offsetLeft
          const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

          const minDragDomTop = dragDom.offsetTop
          const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight

          // 获取到的值带px 正则匹配替换
          let styL = sty(dragDom, 'left')
          let styT = sty(dragDom, 'top')

          // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
          if (styL.includes('%')) {
            styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100)
            styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100)
          } else {
            styL = +styL.replace(/\px/g, '')
            styT = +styT.replace(/\px/g, '')
          }

          document.onmousemove = function(e) {
            // 通过事件委托，计算移动的距离
            let left = e.clientX - disX
            let top = e.clientY - disY

            // 边界处理
            if (-left > minDragDomLeft) {
              left = -minDragDomLeft
            } else if (left > maxDragDomLeft) {
              left = maxDragDomLeft
            }

            if (-top > minDragDomTop) {
              top = -minDragDomTop
            } else if (top > maxDragDomTop) {
              top = maxDragDomTop
            }

            // 移动当前元素
            dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
          }

          document.onmouseup = function(e) {
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      }
    })

    Vue.directive('emoji', {
      inserted: function(el, binding) {
        el.addEventListener('input', function(e) {
          let val = e.target.value
          let reg = /^[a-zA-Z0-9\u4e00-\u9fa5-_\s.,!?\'\"]+$/
          if (!reg.test(val)) {
            // 如果输入不合法，重置为上一个值
            e.target.value = binding.oldValue
          } else {
            // 更新绑定的旧值
            binding.oldValue = val
          }
        })
        el.addEventListener('paste', function(e) {
          // 获取粘贴的文本
          let pastedText = (e.clipboardData || window.clipboardData).getData('text/plain')
          let reg = /^[a-zA-Z0-9\u4e00-\u9fa5-_\s.,!?\'\"]+$/
          if (!reg.test(pastedText)) {
            // 如果粘贴的文本不合法，阻止粘贴事件
            e.preventDefault()
          }
        })
      },
      update: function(el, binding) {
        // 当指令的绑定值更新时，我们也需要更新指令内部的旧值
        binding.oldValue = el.value
      }
    })
  }
}

Vue.use(Directives)



// WEBPACK FOOTER //
// ./src/directive/index.js